import styled from 'styled-components'  
 

export const VideosContent = styled.div.attrs({ 
})`             
`;
export const VideosContentTitle = styled.div.attrs({ 
})`          
    font-size: 20px;
    font-weight: bold;
    color: var(--white-color);    
    margin-left: 180px;   
    margin-bottom: 20px;   

    @media(max-width: 767px){
        margin-left: 20px;
    }
    @media(max-width: 419px){
        margin-left: 12px;
    }
`;
export const VideosContentRow = styled.div.attrs({
})`
    display: flex;
    align-items: center;
    ${
        props => props.gap ? `
            gap: 0 20px;
        ` : `
        `
    }

    /* Com o círculo escondido no celular, damos um respiro à esquerda para o
       primeiro thumb não colar na borda da tela (alinha com o título da fileira). */
    @media(max-width: 767px){
        gap: 0 12px;
        padding-left: 20px;
    }
    @media(max-width: 419px){
        padding-left: 12px;
    }


    ${
        props => props.wrapper ? `
            flex-wrap: wrap;
            gap: 20px;
            padding-left: 180px;

            /* Modo GRADE (Favoritos, Categorias, Busca). No celular vira uma grade
               de 2 colunas com capas uniformes (16:9) — em vez de uma capa gigante. */
            @media(max-width: 767px){
                padding-left: 20px;
                padding-right: 20px;
                gap: 14px;
                align-items: stretch;

                & > div {
                    min-width: 0;
                    width: calc(50% - 7px);
                    height: auto;
                    aspect-ratio: 16 / 9;
                }
            }
            @media(max-width: 419px){
                padding-left: 12px;
                padding-right: 12px;
                gap: 12px;

                & > div {
                    width: calc(50% - 6px);
                }
            }
        ` : ``
    }
`;
export const VideosContentCircle = styled.div.attrs({ 
})`             
    min-width: 70px;
    min-height: 70px;
    border-radius: 35px;

    margin: 0 54px;

    background: var(--white-color);
    display: flex;
    align-items: center;
    justify-content: center;
    ${
        props => props.image ? `
            background: url(${props.image}) no-repeat center center / cover;
            margin: 0 34px 0 54px;
        ` : ``
    }

    /* No celular escondemos o círculo (igual ao app Android), liberando espaço
       para os thumbs ficarem maiores. */
    @media(max-width: 767px){
        display: none;
    }
`;
export const VideosContentCircleSpace = styled.div.attrs({
})`
    min-width: 70px;
    min-height: 70px;
    border-radius: 35px;

    margin: 0 34px 0 54px;

    @media(max-width: 767px){
        display: none;
    }
`;
export const VideosContentCircleIcon = styled.img.attrs(props => ({ 
    src:`/icons/${ props.icon }.svg`   
}))`             
`;
export const VideoContentVideo = styled.div.attrs({ 
})`           
    min-width: 270px;
    height: 151px; 

    background: var(--white-color) url(${ props => props.image ? props.image : '' }) no-repeat center center / cover;

    cursor: pointer;
    &:hover{
        transform: scale(1.2);
    }

    @media(max-width: 499px){
        min-width: 240px;
        height: 135px;
    }

    @media(max-width: 419px){
        min-width: 220px;
        height: 124px;
    }
`;
export const VideoContentVideoDecoration = styled.div.attrs({ 
})`             
`;


export const VideosContentRowScroll = styled.div.attrs({ 
})`             
    overflow: auto;
    padding: 0 0 40px 0;
`;
